export default "__VITE_ASSET__1FYGAjQy__"